import React, { Component } from 'react';
import { FormControlLabel, Checkbox } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles';

class CheckBox extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes } = this.props;
    return (
      <FormControlLabel
        control={
          <Checkbox
            name={this.props.name}
            fullWidth
            checked={this.props.values[this.props.name]}
            value={this.props.values[this.props.name]}
            onChange={this.props.handleChange}
            style={this.props.styles}
          />
        }
        className={classes.labelClass}
      />
    );
  }
}

export default withStyles(useStyles)(CheckBox);
